<template>
  <div>
    <el-switch
        v-model="switchValue"
        :active-value="true"
        :inactive-value="false"
        @change="handleChange"
    ></el-switch>
    <p>当前状态: {{ switchValue ? "开启" : "关闭" }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 初始值为 true
      switchValue: false,
    };
  },
  methods: {
    handleChange(value) {
      // 每当切换时打印当前状态
      console.log('滑动开关的当前状态:', value);
    }
  }
};
</script>

<style scoped>
/* 这里可以添加一些样式 */
</style>
